import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { X } from 'lucide-react';

const SESSION_KEY = 'nli_popup_dismissed';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PopupAd() {
  const [popup, setPopup] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    axios.get(`${API}/settings/popup`).then(res => {
      if (res.data?.enabled) {
        const delay = (res.data.delay_seconds ?? 5) * 1000;
        setTimeout(() => {
          setPopup(res.data);
          setVisible(true);
        }, delay);
      }
    }).catch(() => {});
  }, []);

  if (!visible || !popup) return null;

  const dismiss = () => {
    setVisible(false);
    sessionStorage.setItem(SESSION_KEY, '1');
  };

  return (
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={dismiss}
    >
      <div
        className="relative max-w-md w-full rounded-2xl shadow-2xl overflow-hidden"
        style={{ backgroundColor: popup.bg_color || '#0f2b4a', color: popup.text_color || '#ffffff' }}
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={dismiss}
          className="absolute top-3 right-3 rounded-full bg-black/20 hover:bg-black/40 p-1.5 transition-colors z-10"
          aria-label="Close"
        >
          <X size={16} />
        </button>

        {popup.image && (
          <img src={popup.image} alt="" className="w-full h-48 object-cover" />
        )}

        <div className="p-7">
          {popup.badge && (
            <span className="inline-block text-xs font-bold uppercase tracking-wider bg-white/20 px-3 py-1 rounded-full mb-3">
              {popup.badge}
            </span>
          )}
          {popup.title && (
            <h3 className="text-2xl font-extrabold mb-2">{popup.title}</h3>
          )}
          {popup.message && (
            <p className="text-sm opacity-90 mb-6 leading-relaxed">{popup.message}</p>
          )}
          {popup.cta_text && popup.cta_link && (
            <Link
              to={popup.cta_link}
              onClick={dismiss}
              className="inline-block font-bold px-6 py-2.5 rounded-lg text-sm transition-opacity hover:opacity-90"
              style={{ backgroundColor: popup.text_color || '#ffffff', color: popup.bg_color || '#0f2b4a' }}
            >
              {popup.cta_text}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
